<template>
    <div :class="stackCssClass" class="gap-2"> 
        <SelectField v-model="dropdownValue" :select-items="witnessAgeList" :is-horizontal="false" :is-required="true">
        </SelectField>
        <div :class="stackCssClass" class="gap-2 mt-2 text-start" v-if="selectionMode === 'range'">
            <SelectField v-model="minAge" :select-items="minAges" :is-horizontal="false" :is-required="true" style="min-width:150px;">
                <template #label><label>Min:</label></template>
            </SelectField>
            <SelectField v-model="maxAge" :select-items="maxAges" :is-horizontal="false" :is-required="true" style="min-width:150px;">
                <template #label><label>Max:</label></template>
            </SelectField>
        </div>
    </div>
</template>
<script lang="ts">
    import { defineComponent, PropType, ref } from 'vue';    
    import { SelectItem, AgeRange,SelectValue } from '../../types';
    import SelectField from './SelectField.vue';
    import { useContactsStore } from '../../stores/contactsStore';

    export default defineComponent({
        components: {
            SelectField
        },
        props: {
            isDisabled: {
                default: false,
                type: Boolean
            },
            modelValue: {
                type: [Number,Object,String] as PropType<number | AgeRange | string>
            },
            isHorizontal: {
                default: false,
                type: Boolean
            },
            isRequired: {
                default: false,
                type: Boolean
            }
        },
        methods: {
            handleChange() {
                
                if(this.dropdownValue != '' && !isNaN(Number(this.dropdownValue))) {
                    this.$emit('update:modelValue', Number(this.dropdownValue));
                }
                else if(this.selectionMode === "range"){
                    let rangeData = {upper:this.maxAge, lower:this.minAge};

                    this.$emit('update:modelValue', rangeData);
                }
                else if(this.dropdownValue === 'unknown'){
                    this.$emit('update:modelValue', undefined);
                }
            }
        },
        computed: {
            ages(): SelectItem[] {
                let items = [] as SelectItem[];
                
                Array.from([...this.contactsStore.ages], x=> items.push({label:`${x}`, value:`${x}`, isDisable:false}));
                return items;
            },
            minAges(): SelectItem[] {
                let ageList = [...this.ages].splice(0,this.maxAge-1);

                return ageList;
            },
            maxAges(): SelectItem[] {
                let ageList = [...this.ages].splice(this.minAge-1);

                return ageList;
            },
            witnessAgeList(): SelectItem[] {
                var list = [] as SelectItem[];
                
                list.push({label:'Unknown', value:'UNKNOWN', isDisable:false});
                list.push({label:'Range', value:'range', isDisable:false});
                
                Array.from([...this.contactsStore.ages], x=> list.push({label:`${x}`, value:`${x}`, isDisable:false}));

                return list;  
            },
            selectionMode():string {
                let valueAsNumber = Number(this.dropdownValue);
                
                if(!isNaN(valueAsNumber)){
                    return "exact";
                }

                return this.dropdownValue;
            },
            stackCssClass():String {
                return this.isHorizontal ? "hstack" : "vstack";
            }
        },
        setup(props){
            const contactsStore = useContactsStore();

            contactsStore.fetchAges();
            let dropdownValue = '' as string;
            let minAge = 1;
            let maxAge = 99;

            if(typeof(props.modelValue)=='number'){
                dropdownValue = `${props.modelValue as number}`;                    
            }
            else if(typeof(props.modelValue)=='object'){
                const data = props.modelValue as AgeRange;

                if(data){
                    if(data.upper != undefined){
                        maxAge = data.upper;
                    }

                    if(data.lower != undefined){
                        minAge = data.lower;
                    }
                }                    

                dropdownValue= "range";
            }
            else{
                dropdownValue= props.modelValue ?? "";
            }  

            return { contactsStore, 
                dropdownValue: ref(dropdownValue),                
                minAge,
                maxAge};
        },
        watch: {
            dropdownValue(newValue, oldValue) {
                this.handleChange();                
            },
            minAge(newValue, oldValue) {
                this.handleChange();
            },
            maxAge(newValue, oldValue) {
                this.handleChange();
            }
        }
    });
</script>